//always import console first to avoid console.log in production
import "./console.ts";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import mixpanel from "mixpanel-browser";
import { mixpanelKey } from "./config.ts";
//@ts-expect-error override window.open to avoid popup blockers
window.open = function (url: string) {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer"; // security best practice
    a.style.display = "none"; // keep it invisible
    document.body.appendChild(a);

    a.click(); // trigger navigation
    document.body.removeChild(a); // cleanup
};

window.kefi_bundles = {
    localization: {
        rate: 1,
    },
    prices_synced: true,
} as any;
// injectFonts(FONTS);
mixpanel.init(mixpanelKey, {
    record_sessions_percent: 100,
});
window.showCalloutNudge = true;

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
